module.exports = __webpack_public_path__ + "media/pl_pl_s2_Bolek.37b25906.mp3";